import createSvgIcon from "./utils/create_icon"

const ArrowUp = createSvgIcon(<path d="M14.293 10.707a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 9.414V17a1 1 0 1 0 2 0V9.414z" fill="currentColor" />, "ArrowUp")
export default ArrowUp
